const URL_API_V2 = `${process.env.REACT_APP_TOTY_URL_TERMS}`

export default {
  rewards: {
    find: '/rewards',
  },

  user: {
    acknowledge: '/user/acknowledge',
    find: (phone: string): string => `/clients/${phone}`,
    extract: (phone: string): Record<'score', string> => ({
      score: `/scores/clients/${phone}/history`,
    }),
  },

  orgs: {
    all: '/orgs/all',
  },

  terms: (query: Record<'token' | 'redirect_uri' | 'key', string>): string =>
    `${URL_API_V2}/${query.key}/user?token=${query.token}&redirect_uri=${query.redirect_uri}`,
  termLink: (key: string, term: 'terms-of-use' | 'policy-privacy'): string =>
    `${URL_API_V2}/${key}/${term}`,

  sweepstakes: {
    find: (phone: string) => `/sweepstakes/clients/${phone}`,
    info: (phone: string, id: string) => `/sweepstakes/clients/${phone}/${id}`,
  },
}
